exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cof-field[data-v-04a23164] {\n  min-width: 120px;\n  margin-right: 5px;\n}\n.cof-type[data-v-04a23164] {\n  min-width: 200px;\n}", ""]);

// exports
